import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useWindowWidth } from '../../../utils';
import ConnectionCell from '../../../components/admin/ConnectionCell';
import Select from 'react-select';
import questionImg from '../../../assets/images/question.svg';
import DownloadIcon from '../../../components/icons/DownloadIcon';
import plusImg from '../../../assets/images/plus.svg';
import closeImg from '../../../assets/images/close.svg';
import searchImg from '../../../assets/images/search.svg';
import { CSVLink } from 'react-csv';

import { createConnection, updateConnection, deleteConnection } from '../../../actions/connection';

const customStyles = {
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isFocused ? '#F2F2F2' : null,
    color: '#000000',
    padding: '8px 0 8px 16px',
    fontSize: 14,
    fontWeight: isSelected ? 600 : 300,
  }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
  }),
};

const searchInputStyles = {
  control: (styles) => ({
    ...styles,
    width: 150,
    height: 40,
    backgroundColor: '#E6E9ED',
  }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isFocused ? '#F2F2F2' : null,
    color: '#000000',
    padding: '8px 0 8px 16px',
    fontSize: 14,
    fontWeight: isSelected ? 600 : 300,
  }),
  placeholder: (styles) => ({
    ...styles,
    color: '#9AA5B7',
  }),
};

const types = [
  { label: 'Funding', value: 'Funding' },
  { label: 'Data', value: 'Data' },
  { label: 'Influence', value: 'Influence' },
];

const CustomDropdownIndicator = ({ innerProps }) => {
  return (
    <div className="indicator">
      <img src={searchImg} alt="" />
    </div>
  );
};

const Connection = ({ stakeholders, connections }) => {
  const width = useWindowWidth();
  const dispatch = useDispatch();
  const project = useSelector((state) => state.project.project);

  const [selected, setSelected] = useState('');
  const [isShowAddConnectionModal, setShowAddConnectionModal] = useState(false);
  const [isShowEditConnectionModal, setShowEditConnectionModal] = useState(false);
  const [isShowDeleteConnectionModal, setShowDeleteConnectionModal] = useState(false);
  const [newConnection, setNewConnection] = useState({
    type: '',
    from: '',
    to: '',
    notes: '',
  });

  const csvHeaders = [
    { label: '#', key: 'index' },
    { label: 'Type', key: 'type' },
    { label: 'From', key: 'from' },
    { label: 'To', key: 'to' },
    { label: 'Notes', key: 'notes' },
  ];

  const csvData = connections.map((c, i) => {
    let fromSH = stakeholders.find((s) => s.id === c.from);
    let toSH = stakeholders.find((s) => s.id === c.from);
    return {
      index: i + 1,
      type: c.type,
      from: fromSH ? fromSH.name : '',
      to: toSH ? toSH.name : '',
      notes: c.notes,
    };
  });
  // .map((c) => Object.values(c));

  const handleNewChange = (name, e) => {
    setNewConnection({ ...newConnection, [name]: e });
  };

  const handleEditChange = (name, e) => {
    setSelected({ ...selected, [name]: e });
  };

  const handleAddConnection = () => {
    if (!newConnection.type || !newConnection.from || !newConnection.to) return;
    if (project) {
      dispatch(
        createConnection({
          projectId: project.id,
          type: newConnection.type.value,
          from: newConnection.from.id,
          to: newConnection.to.id,
          notes: newConnection.notes,
          createdAt: new Date(),
        }),
      );
    }
    setShowAddConnectionModal(false);
    setNewConnection({
      type: '',
      from: '',
      to: '',
      notes: '',
    });
  };

  const handleEditConnection = () => {
    if (!selected.type || !selected.from || !selected.to) return;
    dispatch(
      updateConnection({
        ...selected,
        type: selected.type.value,
        from: selected.from.id,
        to: selected.to.id,
        updatedAt: new Date(),
      }),
    );
    setShowEditConnectionModal(false);
  };

  const handleDeleteConnection = () => {
    dispatch(deleteConnection(selected.id));
    setShowDeleteConnectionModal(false);
  };

  const renderTooltip = (props) => (
    <Tooltip id="custom-tooltip" {...props}>
      <div className="custom-tooltip">
        <div className="tooltip-header">Connection!</div>
        <div className="tooltip-content">
          Here is where you add the relationships between your stakeholders. These become arrows in
          the web.
        </div>
      </div>
    </Tooltip>
  );

  const [searchStr, setSearchStr] = useState('');

  return (
    <>
      <div className="connection-section">
        <div className="connection-section-header">
          <div className="text-section">
            <p>Connections</p>
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
            >
              <img src={questionImg} alt="quiz" />
            </OverlayTrigger>
          </div>
          <div className="right-section">
            <div className="header-actions">
              <CSVLink
                filename={'connections.csv'}
                data={csvData}
                headers={csvHeaders}
                className={`csv-btn outline-btn ${csvData.length === 0 ? 'disabled' : ''}`}
              >
                <DownloadIcon color={csvData.length === 0 ? '#DCDAFF' : '#594FD1'} />
                Export CSV
              </CSVLink>
              <button
                className="primary-btn"
                disabled={project === '' || stakeholders.length === 0}
                onClick={() => setShowAddConnectionModal(true)}
              >
                <img src={plusImg} alt="Add Connection" />
                Add Connection
              </button>
            </div>
            <input
              id="filter"
              name="filter"
              value={searchStr}
              onChange={(e) => setSearchStr(e.target.value)}
              placeholder="Search"
              classNamePrefix="custom-select"
              className="custom-select"
            />
            {/* <Select
              id="search_type"
              name="search_type"
              options={types}
              styles={searchInputStyles}
              placeholder="Search"
              classNamePrefix="custom-select"
              className="custom-select"
              rules={{ required: 'Select' }}
              getOptionValue={(option) => option.value}
              getOptionLabel={(option) => option.label}
              components={{
                DropdownIndicator: CustomDropdownIndicator,
              }}
            /> */}
          </div>
        </div>
        <div className="connection-list">
          {width > 600 ? (
            <div className="connection-list-header">
              <div className="item-id">#</div>
              <div className="item-type">Type</div>
              <div className="item-from">From</div>
              <div className="item-to">To</div>
              <div className="item-notes">Notes</div>
            </div>
          ) : (
            <></>
          )}
          <div className="connection-list-content">
            {connections
              .map((connection) => {
                return {
                  ...connection,
                  from: stakeholders.find((s) => s.id === connection.from),
                  to: stakeholders.find((s) => s.id === connection.to),
                };
              })
              .filter(
                (c) =>
                  searchStr === '' ||
                  c.type.includes(searchStr) ||
                  c.from.name.includes(searchStr) ||
                  c.to.name.includes(searchStr) ||
                  c.notes.includes(searchStr),
              )
              .map((connection, index) => (
                <ConnectionCell
                  connection={connection}
                  key={connection.id}
                  index={index + 1}
                  setShowEditConnectionModal={setShowEditConnectionModal}
                  setShowDeleteConnectionModal={setShowDeleteConnectionModal}
                  setSelected={setSelected}
                  stakeholders={stakeholders}
                />
              ))}
          </div>
        </div>
      </div>
      {isShowAddConnectionModal && (
        <div className="custom-modal">
          <div className="modal-card">
            <img
              src={closeImg}
              alt=""
              className="close-btn"
              onClick={() => setShowAddConnectionModal(false)}
            />
            <div className="modal-card-inner">
              <h1 className="title">Add Connection</h1>
              <div className="form-item">
                <label htmlFor="type">Select Connection Type</label>
                <Select
                  id="type"
                  name="type"
                  value={newConnection.type}
                  onChange={(e) => handleNewChange('type', e)}
                  options={types}
                  styles={customStyles}
                  placeholder="Select"
                  classNamePrefix="custom-select"
                  className="custom-select"
                  rules={{ required: 'Select' }}
                  getOptionValue={(option) => option.value}
                  getOptionLabel={(option) => option.label}
                />
              </div>
              <div className="form-item">
                <label htmlFor="from">From</label>
                <Select
                  id="from"
                  name="from"
                  value={newConnection.from}
                  onChange={(e) => handleNewChange('from', e)}
                  options={stakeholders}
                  styles={customStyles}
                  placeholder="Select"
                  classNamePrefix="custom-select"
                  className="custom-select"
                  rules={{ required: 'Select' }}
                  getOptionValue={(option) => option.id}
                  getOptionLabel={(option) => option.name}
                />
              </div>
              <div className="form-item">
                <label htmlFor="to">To</label>
                <Select
                  id="to"
                  name="to"
                  value={newConnection.to}
                  onChange={(e) => handleNewChange('to', e)}
                  options={stakeholders}
                  styles={customStyles}
                  placeholder="Select"
                  classNamePrefix="custom-select"
                  className="custom-select"
                  rules={{ required: 'Select' }}
                  getOptionValue={(option) => option.id}
                  getOptionLabel={(option) => option.name}
                />
              </div>
              <div className="form-item">
                <label htmlFor="notes">Notes</label>
                <textarea
                  name="notes"
                  id="notes"
                  rows="2"
                  value={newConnection.notes}
                  onChange={(e) => handleNewChange('notes', e.target.value)}
                ></textarea>
              </div>
              <button className="primary-btn solo-btn" onClick={handleAddConnection}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {isShowEditConnectionModal && (
        <div className="custom-modal">
          <div className="modal-card">
            <img
              src={closeImg}
              alt=""
              className="close-btn"
              onClick={() => setShowEditConnectionModal(false)}
            />
            <div className="modal-card-inner">
              <h1 className="title">Edit Connection</h1>
              <div className="form-item">
                <label htmlFor="type">Select Connection Type</label>
                <Select
                  id="edit-type"
                  name="type"
                  value={selected.type}
                  onChange={(e) => handleEditChange('type', e)}
                  options={types}
                  styles={customStyles}
                  placeholder="Select"
                  classNamePrefix="custom-select"
                  className="custom-select"
                  rules={{ required: 'Select' }}
                  getOptionValue={(option) => option.value}
                  getOptionLabel={(option) => option.label}
                />
              </div>
              <div className="form-item">
                <label htmlFor="from">From</label>
                <Select
                  id="edit-from"
                  name="from"
                  value={selected.from}
                  onChange={(e) => handleEditChange('from', e)}
                  options={stakeholders}
                  styles={customStyles}
                  placeholder="Select"
                  classNamePrefix="custom-select"
                  className="custom-select"
                  rules={{ required: 'Select' }}
                  getOptionValue={(option) => option.id}
                  getOptionLabel={(option) => option.name}
                />
              </div>
              <div className="form-item">
                <label htmlFor="to">To</label>
                <Select
                  id="edit-to"
                  name="to"
                  value={selected.to}
                  onChange={(e) => handleEditChange('to', e)}
                  options={stakeholders}
                  styles={customStyles}
                  placeholder="Select"
                  classNamePrefix="custom-select"
                  className="custom-select"
                  rules={{ required: 'Select' }}
                  getOptionValue={(option) => option.id}
                  getOptionLabel={(option) => option.name}
                />
              </div>
              <div className="form-item">
                <label htmlFor="notes">Notes</label>
                <textarea
                  name="notes"
                  id="edit-notes"
                  rows="2"
                  value={selected.notes}
                  onChange={(e) => handleEditChange('notes', e.target.value)}
                ></textarea>
              </div>
              <button className="primary-btn solo-btn" onClick={handleEditConnection}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {isShowDeleteConnectionModal && (
        <div className="custom-modal">
          <div className="modal-card">
            <img
              src={closeImg}
              alt=""
              className="close-btn"
              onClick={() => setShowDeleteConnectionModal(false)}
            />
            <div className="modal-card-inner">
              <h1 className="title">Are you sure, that you want to delete {selected.name} ?</h1>
              <div className="modal-actions">
                <button className="primary-btn" onClick={handleDeleteConnection}>
                  Yes
                </button>
                <button className="outline-btn" onClick={() => setShowDeleteConnectionModal(false)}>
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Connection;
